import { mapActions, mapGetters, mapState } from 'vuex';
import accountDesktopHeader from '@/components/account/account-desktop-header/account-desktop-header.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import deposit from '@/components/wallet/deposit/deposit.vue';
import profile from '@/components/account/profile/profile.vue';
import tabs from '@/components/generics/tabs/tabs.vue';
import withdraw from '@/components/wallet/withdraw/withdraw.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { capitalizeFirstLetter } from '@/utils/helpers';

const TAB_DEPOSIT = 'deposit';
const TAB_WITHDRAW = 'withdraw';

export default {
  mixins: [
    accountVerifyMixin,
  ],
  components: {
    accountDesktopHeader,
    alertBox,
    contentHeader,
    deposit,
    profile,
    tabs,
    withdraw,
  },
  data() {
    return {
      capitalizeFirstLetter,
      ready: false,
      activeTab: '',
      tabs: [
        { name: TAB_DEPOSIT, title: 'Deposit' },
        { name: TAB_WITHDRAW, title: 'Withdraw' },
      ],
    };
  },
  metaInfo() {
    return {
      title: 'Wallet',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile', 'hasMaintenance', 'isShutdownModeOn']),
    ...mapState('user', ['userData']),
    gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile,
      };
    },
    showDepositTab() {
      return this.activeTab === TAB_DEPOSIT;
    },
    showWithdrawTab() {
      return this.activeTab === TAB_WITHDRAW;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    tabChange(name) {
      this.activeTab = name;
      if (this.isLayoutDesktop) {
        this.$router.push({
          name: 'wallet',
          query: {
            ...this.$route.query,
            tabId: this.activeTab,
          },
        });
      }
    },
  },
  watch: {
    '$route.query' (value) {
      if (value.tabId && value.tabId !== this.activeTab) {
        this.activeTab = value.tabId;
      }
    },
  },
  created() {
    if (!this.isUserVerified) this.showAccountVerifyPopup();
    if (this.$route.query.tabId) {
      this.activeTab = this.$route.query.tabId;
    } else {
      this.activeTab = TAB_DEPOSIT;
      this.$router.push({
        name: 'wallet',
        query: {
          ...this.$route.query,
          tabId: this.activeTab,
        },
      });
    }
    this.ready = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/wallet.js